//@ts-check
import addDesignTrunk from './addDesignTrunk';
import isRelative from './isRelative';
import cleanPath from './cleanPath';
/**
 * @type {import("./types").absoluteType}
 */

export default (function (relativePath, basePath) {
  if (!basePath) return relativePath;
  if (!relativePath) return relativePath;
  relativePath = cleanPath(relativePath);
  basePath = cleanPath(basePath); //already absolute

  if (!isRelative(relativePath)) return addDesignTrunk(relativePath);
  var stack = addDesignTrunk(basePath).split('/');
  var parts = relativePath.split('/'); //remove current file name (or empty string)
  //omit if "base" is the current folder without trailing slash

  if (stack[stack.length - 1].indexOf('.') != -1) stack.pop();

  for (var i = 0; i < parts.length; i++) {
    if (parts[i] == '.') continue;
    if (parts[i] == '..') stack.pop();else stack.push(parts[i]);
  }

  return stack.join('/');
});